import clsx from "clsx";
import styles from "./Icon.module.css";

export type Color = "red" | "grey-42" | "grey-61" | "grey-85";

export function iconColorClasses(color: Color) {
    return clsx({
        [styles.red]: color === "red",
        [styles.gray42]: color === "grey-42",
        [styles.gray61]: color === "grey-61",
        [styles.gray85]: color === "grey-85",
   });
}
